import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(content)/resetpassword/page.js")